var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowIosDown = function ArrowIosDown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.232 9.36a1 1 0 0 1 1.408-.128L12 13.698l5.36-4.466a1 1 0 0 1 1.28 1.536l-6 5a1 1 0 0 1-1.28 0l-6-5a1 1 0 0 1-.128-1.408Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ArrowIosDown;